import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="border-t border-primary/20 bg-background py-16 sm:py-20" aria-labelledby="guarantee-title" data-id="element-74" data-mp="4vs0rz0u8fre">
      <div className="mx-auto max-w-2xl px-4 text-center" data-id="element-75" data-mp="9t1pfcgekne6">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="rounded-3xl border-2 border-primary bg-surface p-8 shadow-glow sm:p-12" data-id="element-76" data-mp="euh8iyz0sjtx">
          <span className="inline-flex rounded-full bg-gold p-4 text-gold-foreground shadow-glow-gold" data-id="element-77" data-mp="slmai7pv1o7f">
            <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-78" data-mp="xm1ngy68ctov" />
          </span>
          <h2 id="guarantee-title" className="mt-6 text-4xl font-bold tracking-tight text-foreground" data-id="element-79" data-mp="12kv2ww52uuro">
            7-Day Guarantee
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-80" data-mp="25rnf6olk22o0">
            Study all 6 volumes and 5 bonuses in your specific hydrogen focus area this week. If the technical depth
            doesn't match your professional needs or materials don't enhance your capability,{' '}
            <span className="font-extrabold text-primary-strong" data-id="element-81" data-mp="1rs5p85wiwjd2">we refund 100%. No questions. No complications.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}